// 尺寸454*320
import React from 'react'
import SkuCheckPage from '@/pages/AndroidDevice/skuCheck/skuCheck'
const ReprintSCPage = () => {
  return <SkuCheckPage checkType="sc"></SkuCheckPage>
}
export default ReprintSCPage
